import { NavParams, ViewController } from 'ionic-angular';
import { Component } from '@angular/core';

/**
 * Generated class for the DeleteModalComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'delete-modal',
  templateUrl: 'delete-modal.html'
})
export class DeleteModalComponent {

  text: string;
  data: any;
  constructor(params : NavParams, private viewCtrl: ViewController) {
    this.data = params.get("data");
  }

  OnResponse(res: boolean){
    this.viewCtrl.dismiss(res);
  }
}



// WEBPACK FOOTER //
// ./src/components/delete-modal/delete-modal.ts